module.exports = __webpack_public_path__ + "static/media/mjølk.b3ca3e7e.mp3";